import {
  WSAvatar,
  WSDivider,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { useQueryOutstandingInvoices } from "../../query/payments/queries";
import { DownloadInvoicesCSV } from "./DownloadInvoicesCSV";
import { InvoicesTable } from "./InvoicesTable";

export const TableInvoicesOutstanding: React.FC = () => {
  const queryInvoices = useQueryOutstandingInvoices();

  const invoices = queryInvoices.data || [];

  return (
    <InvoicesTable
      title="Outstanding"
      actions={
        <DownloadInvoicesCSV
          invoices={invoices}
          isDataReady={queryInvoices.status === "success"}
        />
      }
      invoices={invoices}
      bulkActions={["accept", "dispute"]}
      emptyState={
        <>
          <WSText.Heading5 mb="XL">Outstanding</WSText.Heading5>
          <WSDivider mb="XL" />
          <WSFlexBox direction="column" alignItems="center" wrap="nowrap">
            <WSFlexBox mb="M">
              <WSAvatar.Icon
                icon="check-envelope"
                color="blue500"
                colorBackground="blue50"
                mr="M"
              />
              <WSAvatar.Icon
                icon="check-envelope"
                color="blue500"
                colorBackground="blue50"
                badge
                badgeProps={{
                  icon: "alert-circle-fill",
                  theme: "red"
                }}
              />
            </WSFlexBox>
            <WSText color="gray500">
              Open invoices will be listed here until they are paid
            </WSText>
          </WSFlexBox>
        </>
      }
    />
  );
};
